import { JobProps } from "utils/types";
import React, {FC, useState} from "react";
import styles from "../ShiftDetail.module.scss";
import {exitReact} from "../../../../utils";
import useActionApi from "../../../../hooks/useActionApi";
import Api from "../../../../api";
import FixedLoader from "components/FixedLoader/FixedLoader";
import clsx from "clsx";
import {JOB_STATUSES} from "../ShiftDetailPage";
import dayjs from "dayjs";
import {ShiftPopup} from "./index";
import Popup from "../../../../components/Popup";
import {StyledButton} from "components/Buttons/DefaultButton/DefaultButton.styles";

// @ts-ignore
const TempStars = window.TempStars

const CompleteShiftModal:FC<{
    job: JobProps,
    history: any,
    trackData: any,
}> = (
    {
        job,
        history,
        trackData,
    }) => {
    const [isOpenCompleteShiftModal, setIsOpenCompleteShiftModal] = useState<boolean>(false);

    const [completeJobLoading, , completeJob] = useActionApi({
        apiMethod: Api.completeJob,
    });

    const isTodayOrBefore = !dayjs(job.startDate).isAfter(dayjs())

    const onCompleteShift = async () => {
        setIsOpenCompleteShiftModal(false)
        await completeJob(job.id)
        TempStars.Analytics.track( 'mark shift as completed', trackData );
        history.push('loading')
        exitReact('home')
    }

    return (JOB_STATUSES.CONFIRMED === job.status && isTodayOrBefore ? <>
        <Popup opened={isOpenCompleteShiftModal} onClose={() => setIsOpenCompleteShiftModal(false)}>
            <ShiftPopup
                title={'Shift Completed?'}
                submit={'Mark as Complete'}
                close={'Cancel'}
                job={job}
                onClose={() => setIsOpenCompleteShiftModal(false)}
                onSubmit={onCompleteShift}
            />
        </Popup>

        <StyledButton
            className={clsx(styles.completeButton)}
            variant="contained"
            color="primary"
            size="large"
            id="complete-button"
            onClick={() => setIsOpenCompleteShiftModal(true)}
        >
            Mark Shift Completed
        </StyledButton>

        <FixedLoader
            loading={completeJobLoading}
        />
    </> : null)
}

export default CompleteShiftModal;